<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">EC企画商品別カテゴリ設定一覧表</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
                  [(ngModel)]="kymw5800Model.orderCode" [required]="true" [catalogIDField]="lbl_CatalogId"
                  [autofocus]="true" (ngModelChange)="eventOrderCode_CHANGEHandler()" [forcedEnabledMode]="'true'"
                  [tabindex]="0">
                </app-order-code-text-input>
              </div>

              <label class="list-input-title">配達企画回（翌週）</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="lbl_CatalogId" #lbl_CatalogId readonly>
              </div>

              <label class="list-input-title">サイト区分</label>
              <div class="list-input-content" style="width: 140px">
                <app-code-combo-box id="cmb_SiteDiv" #cmb_SiteDiv [subid]="'cmb_SiteDiv'"
                  [(ngModel)]="kymw5800Model.siteDiv" [codeDiv]="'ctp068'" [initFocusItem]="txti_OrderCode"
                  [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-code-combo-box>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">部門</label>
              <div class="list-input-content" style="width: 300px">
                <app-class-code-combo-box id="cmb_ClassCode" [subid]="'cmb_ClassCode'" [initFocusItem]="txti_OrderCode"
                  [(ngModel)]="kymw5800Model.classCode" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-class-code-combo-box>
              </div>

              <label class="list-input-title">カテゴリ</label>
              <div class="list-input-content">
                <app-cws-plan-category-code-combo-box id="cmb_CategoryCode" #cmb_CategoryCode
                  [subid]="'cmb_CategoryCode'" [(ngModel)]="kymw5800Model.categoryCode" [categoryLevel]="1"
                  [blank]="true" [initFocusItem]="txti_OrderCode" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-cws-plan-category-code-combo-box>
              </div>

              <label class="list-input-title">媒体</label>
              <div class="list-input-content">
                <app-plan-medium-type-combo-box id="cmb_MediumType" #cmb_MediumType [subid]="'cmb_MediumType'"
                  [(ngModel)]="kymw5800Model.mediumType" [initFocusItem]="txti_OrderCode" [forcedEnabledMode]="'true'"
                  [tabindex]="0" style="width: 100%;">
                </app-plan-medium-type-combo-box>
              </div>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <app-checkbox-label label="全" id="chk_AllCoop" #chk_AllCoop [subid]="'chk_AllCoop'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw5800Model.allCoop"
                (change)="eventAllCoop_CHANGEHandler()">
              </app-checkbox-label>
              <app-checkbox-label label="い" id="chk_Ibaraki" #chk_Ibaraki [subid]="'chk_Ibaraki'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw5800Model.ibaraki">
              </app-checkbox-label>
              <app-checkbox-label label="と" id="chk_Tochigi" #chk_Tochigi [subid]="'chk_Tochigi'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw5800Model.tochigi">
              </app-checkbox-label>
              <app-checkbox-label label="ぐ" id="chk_Gunma" #chk_Gunma [subid]="'chk_Gunma'" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5800Model.gunma">
              </app-checkbox-label>
              <app-checkbox-label label="ち" id="chk_Chiba" #chk_Chiba [subid]="'chk_Chiba'" [forcedEnabledMode]="'true'"
                [tabindex]="0" [(ngModel)]="kymw5800Model.chiba">
              </app-checkbox-label>
              <app-checkbox-label label="さ" id="chk_Saitama" #chk_Saitama [subid]="'chk_Saitama'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw5800Model.saitama">
              </app-checkbox-label>
              <app-checkbox-label label="とう" id="chk_Tokyo" #chk_Tokyo [subid]="'chk_Tokyo'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw5800Model.tokyo">
              </app-checkbox-label>
              <app-checkbox-label label="な" id="chk_Nagano" #chk_Nagano [subid]="'chk_Nagano'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw5800Model.nagano">
              </app-checkbox-label>
              <app-checkbox-label label="に" id="chk_Niigata" #chk_Niigata [subid]="'chk_Niigata'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw5800Model.niigata">
              </app-checkbox-label>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Output" class="btn-primary" (click)="eventCSVOut_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>